import PlaceholderImage from "src/components/nodata/PlaceholderImage";
import { classNames } from "src/helpers/classNames";

export default function FeaturesSection({ data }) {
  return (
    <section className={classNames(data?.hidden ? "hidden" : "animate-fade-in relative mx-auto mt-20 max-w-7xl px-8 md:mt-36 md:px-6")}>
      <div className="relative isolate overflow-hidden bg-slate-900 px-6 py-20 md:rounded-3xl md:px-10 md:py-24 lg:px-32 lg:py-24">
        <div className="mx-auto grid max-w-2xl grid-cols-1 items-center gap-x-8 gap-y-16 md:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2 lg:gap-y-0">
          <div className="lg:row-start-2 lg:max-w-md">
            <h2 className="text-3xl font-semibold tracking-tight text-white [text-wrap:balance] md:text-4xl">{data?.title}</h2>
            <p className="mt-6 text-lg text-slate-300">{data?.description}</p>
          </div>
          <div className="relative -z-20 min-w-full max-w-2xl overflow-hidden rounded-xl shadow-xl ring-1 ring-slate-100/10 lg:row-span-4 lg:w-[64rem] lg:max-w-none">
            {data?.image ? (
              <img
                alt="Product screenshot"
                src={data?.image}
                width="2432"
                height="1442"
                className=""
              />
            ) : (
              <PlaceholderImage
                containerClasses="!opacity-20"
                textClasses="text-2xl !hidden"
              />
            )}
          </div>
          {data?.features?.length > 0 && (
            <div className="max-w-2xl lg:row-start-3 lg:mt-10 lg:max-w-md lg:border-t lg:border-slate-100/10 lg:pt-10">
              <dl className="max-w-2xl space-y-8 text-base text-slate-300 lg:max-w-none">
                {data?.features?.map((item, index) => (
                  <div
                    className="relative"
                    key={index}>
                    <dt className="ml-9 inline-block font-semibold text-white">
                      <span
                        className="absolute left-1 top-0.5 h-5 w-5 text-indigo-500"
                        dangerouslySetInnerHTML={{ __html: item?.icon }}
                      />
                      {item?.title}
                    </dt>
                    <dd className="ml-2 inline">{item?.description}</dd>
                  </div>
                ))}
              </dl>
            </div>
          )}
        </div>
        <div
          aria-hidden="true"
          className="pointer-events-none absolute left-12 top-1/2 -z-10 -translate-y-1/2 transform-gpu blur-3xl lg:-bottom-48 lg:top-auto lg:translate-y-0">
          <div className="aspect-[1155/678] w-[72rem] bg-gradient-to-tr from-pink-400 to-violet-400 opacity-25 [clip-path:polygon(74.1%_44.1%,100%_61.6%,97.5%_26.9%,85.5%_0.1%,80.7%_2%,72.5%_32.5%,60.2%_62.4%,52.4%_68.1%,47.5%_58.3%,45.2%_34.5%,27.5%_76.7%,0.1%_64.9%,17.9%_100%,27.6%_76.8%,76.1%_97.7%,74.1%_44.1%)]" />
        </div>
      </div>
    </section>
  );
}
